module.exports = __webpack_public_path__ + "static/Kelly-Portrait-Desktop-bf8b219918291ed72d47730c17362d66.jpg";